import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { CONTACT, EVENT, FORM_ENDPOINT, MAPS_URL } from '../data/invitation';
type Attendance = 'kosilo' | 'vecerja' | 'oboje';
const OPTIONS: {
  value: Attendance;
  label: string;
}[] = [{
  value: 'kosilo',
  label: 'Kosilo'
}, {
  value: 'vecerja',
  label: 'Večerja'
}, {
  value: 'oboje',
  label: 'Oboje'
}];
const labelClass = 'block text-[0.65rem] uppercase tracking-label text-paper-300';
const fieldClass = 'mt-3 w-full rounded-sm border border-paper-100/20 bg-transparent px-4 py-3.5 text-base text-paper-50 placeholder:text-paper-300/40 transition-colors duration-200 ease-chapter focus:border-accent-300 focus:outline-none focus:ring-1 focus:ring-accent-300';
export function Rsvp() {
  const [name, setName] = useState('');
  const [adults, setAdults] = useState('2');
  const [kids, setKids] = useState('0');
  const [attendance, setAttendance] = useState<Attendance | ''>('');
  const [extra, setExtra] = useState('');
  const [status, setStatus] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle');
  const sent = status === 'sent';
  const sending = status === 'sending';
  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!attendance || sending) return;
    setStatus('sending');
    const attendanceLabel = OPTIONS.find(o => o.value === attendance)?.label ?? attendance;
    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          _subject: `Prijava na 40. poglavje — ${name}`,
          'Ime in priimek': name,
          'Število odraslih': adults,
          'Število otrok': kids,
          Udeležba: attendanceLabel,
          Dodatno: extra
        })
      });
      if (!response.ok) throw new Error('Formspree request failed');
      setStatus('sent');
    } catch {
      setStatus('error');
    }
  }
  return <section id="prijava" className="w-full bg-ink-900 px-6 py-24 text-paper-50 sm:px-10 sm:py-32 lg:px-16" data-id="element-55" data-mp="1s538fozg637c">
      <div className="mx-auto max-w-5xl" data-id="element-56" data-mp="1w9kll5baxi95">
        <div className="grid gap-14 lg:grid-cols-[1fr_1.15fr] lg:gap-24" data-id="element-57" data-mp="1i904cdl1buhr">
          <Reveal data-id="element-58" data-mp="1iat9tpjww8o6">
            <p className="text-[0.65rem] uppercase tracking-label text-accent-300" data-id="element-59" data-mp="1n71n0xejtrsp">Prijava</p>
            <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-paper-50 sm:text-5xl" data-id="element-60" data-mp="2axe5313id4x0">
              Potrdi udeležbo
            </h2>
            <p className="mt-8 max-w-md text-base leading-relaxed text-paper-300/80 sm:text-lg" data-id="element-61" data-mp="2fvpamzmrst9f">
              Da bomo približno vedeli, koliko hrane pripraviti in koliko stolov, kozarcev ter drugih življenjsko pomembnih stvari potrebujemo, prosim izpolni priloženi obrazec.
            </p>

            <dl className="mt-10 space-y-4 border-t border-paper-100/15 pt-8 text-sm" data-id="element-62" data-mp="2tufb8p8stb2j">
              <div className="flex items-baseline gap-4" data-id="element-63" data-mp="2yni75411swlw">
                <dt className="w-16 shrink-0 text-[0.6rem] uppercase tracking-label text-accent-300/70" data-id="element-64" data-mp="n7hoj5tn2oym">
                  Kdaj
                </dt>
                <dd className="font-serif text-xl font-light text-paper-50" data-id="element-65" data-mp="i852uoei7nxm">{EVENT.dateLong}</dd>
              </div>
              <div className="flex items-baseline gap-4" data-id="element-66" data-mp="vz9sqys2l1ur">
                <dt className="w-16 shrink-0 text-[0.6rem] uppercase tracking-label text-accent-300/70" data-id="element-67" data-mp="ry7tihy5kpss">
                  Kje
                </dt>
                <dd className="font-serif text-xl font-light text-paper-50" data-id="element-68" data-mp="4azqk6o75stx">
                  <a href={MAPS_URL} target="_blank" rel="noreferrer" className="underline decoration-paper-300/30 decoration-1 underline-offset-4 transition-colors duration-200 ease-chapter hover:text-accent-300 hover:decoration-accent-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-accent-300" data-id="element-69" data-mp="3vgrdyyalard1">
                    {EVENT.place}
                  </a>
                </dd>
              </div>
            </dl>
          </Reveal>

          <div data-id="element-70" data-mp="2jzyjekda7rhz">
            {sent ? <motion.div initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.28,
            ease: [0.23, 1, 0.32, 1]
          }} role="status" className="border-y border-accent-300/40 py-16" data-id="element-71" data-mp="2k0qd1pnbjf5m">
                <p className="font-serif text-3xl font-light leading-snug text-paper-50 sm:text-4xl" data-id="element-72" data-mp="2xwu0n03osp94">
                  Hvala! Tvoja udeležba je zabeležena. Zdaj ni več poti nazaj.
                </p>
              </motion.div> : <Reveal delay={0.06} data-id="element-73" data-mp="3cmj5p6ewhdeo">
                <form onSubmit={handleSubmit} className="space-y-8" noValidate={false} data-id="element-74" data-mp="3cpnigs6flhgy">
                  <div data-id="element-75" data-mp="3hoibemy44mes">
                    <label htmlFor="ime" className={labelClass} data-id="element-76" data-mp="3hkuh3lkufvz0">
                      Ime in priimek
                    </label>
                    <input id="ime" name="ime" required autoComplete="name" value={name} onChange={e => setName(e.target.value)} className={fieldClass} data-id="element-77" data-mp="1a1f9j2g82ex7" />
                  </div>

                  <div className="grid grid-cols-2 gap-5" data-id="element-78" data-mp="w38tl1b8azlt">
                    <div data-id="element-79" data-mp="1tnv2ujde94z9">
                      <label htmlFor="odrasli" className={labelClass} data-id="element-80" data-mp="1to3e66tvc28c">
                        Število odraslih
                      </label>
                      <input id="odrasli" name="odrasli" type="number" inputMode="numeric" min={1} max={20} required value={adults} onChange={e => setAdults(e.target.value)} className={fieldClass} data-id="element-81" data-mp="1jytosyqesxnx" />
                    </div>
                    <div data-id="element-82" data-mp="9spin6lmwjqp">
                      <label htmlFor="otroci" className={labelClass} data-id="element-83" data-mp="9syyi1cytaio">
                        Število otrok
                      </label>
                      <input id="otroci" name="otroci" type="number" inputMode="numeric" min={0} max={20} value={kids} onChange={e => setKids(e.target.value)} className={fieldClass} data-id="element-84" data-mp="3s6gbbakjw1k0" />
                    </div>
                  </div>

                  <fieldset data-id="element-85" data-mp="3e7yqbkm1535s">
                    <legend className={labelClass} data-id="element-86" data-mp="3e777799mcxwe">Udeležba</legend>
                    <div className="mt-3 grid grid-cols-3 gap-2" data-id="element-87" data-mp="17hiwqloe31nx">
                      {OPTIONS.map(o => {
                    const active = attendance === o.value;
                    return <label key={o.value} className={`cursor-pointer rounded-sm border px-2 py-3.5 text-center text-sm transition-colors duration-200 ease-chapter ${active ? 'border-accent-300 bg-paper-50 text-ink-900' : 'border-paper-100/20 text-paper-300/80 hover:border-accent-300/60'}`} data-id="element-88" data-mp="1mkak3j4oyh6s">
                            <input type="radio" name="udelezba" value={o.value} required checked={active} onChange={() => setAttendance(o.value)} className="sr-only" data-id="element-89" data-mp="20adyjnxbx6lo" />
                            {o.label}
                          </label>;
                  })}
                    </div>
                  </fieldset>

                  <div data-id="element-90" data-mp="19e1zt1bt9d49">
                    <label htmlFor="dodatno" className={labelClass} data-id="element-91" data-mp="19dipa5ohpr09">
                      Dodatno
                    </label>
                    <textarea id="dodatno" name="dodatno" rows={4} value={extra} onChange={e => setExtra(e.target.value)} placeholder="Alergije, posebnosti glede hrane ali karkoli drugega, kar bi moral vedeti ..." className={`resize-none ${fieldClass}`} data-id="element-92" data-mp="1e869hscgnz91" />
                  </div>

                  <div className="space-y-4" data-id="element-93" data-mp="zhp828ztt9c5">
                    <button type="submit" disabled={sending} className="w-full rounded-sm bg-paper-50 px-8 py-4 text-xs font-semibold uppercase tracking-[0.18em] text-ink-900 transition-colors duration-200 ease-chapter hover:bg-accent-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-accent-300 disabled:cursor-not-allowed disabled:opacity-60 sm:w-auto" data-id="element-94" data-mp="25wzx4b570esn">
                      {sending ? 'Pošiljam ...' : 'Potrdi prihod'}
                    </button>

                    {status === 'error' && <p role="alert" className="text-sm leading-relaxed text-accent-300" data-id="element-95" data-mp="22ajjzcku3cov">
                        Prijave ni bilo mogoče poslati. Poskusi še enkrat ali mi kar piši
                        neposredno.
                      </p>}
                  </div>
                </form>
              </Reveal>}

            <Reveal delay={0.1} data-id="element-96" data-mp="1obtkjqajl0xc">
              <p className="mt-10 border-t border-paper-100/15 pt-8 text-sm leading-relaxed text-paper-300/70" data-id="element-97" data-mp="3mpvbgym45xmy">
                Če ti je lažje, lahko udeležbo javiš tudi po telefonu na{' '}
                <a href={CONTACT.phoneHref} className="whitespace-nowrap text-paper-50 underline decoration-paper-300/30 decoration-1 underline-offset-4 transition-colors duration-200 ease-chapter hover:text-accent-300 hover:decoration-accent-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-accent-300" data-id="element-98" data-mp="2dq762lo6drtx">
                  {CONTACT.phoneLabel}
                </a>{' '}
                (Tobija) ali na e-naslov{' '}
                <a href={`mailto:${CONTACT.email}`} className="whitespace-nowrap text-paper-50 underline decoration-paper-300/30 decoration-1 underline-offset-4 transition-colors duration-200 ease-chapter hover:text-accent-300 hover:decoration-accent-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-accent-300" data-id="element-99" data-mp="1q1nyy9gv3l3f">
                  {CONTACT.email}
                </a>
                .
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>;
}